// extracted by mini-css-extract-plugin
module.exports = {"collectionModal":"CreateCollectionModal_collectionModal___xQCR"};